import {
    DELETE_GATEWAY_REQUEST,
    DELETE_GATEWAY,
    CLEAR_STORE
} from './constants';
import { getApiActionCreator } from 'helpers/actionHelper';
export const getGatewayDeleteAction = getApiActionCreator(DELETE_GATEWAY);
export const deleteGatewayRequest = (gatewayID, organizationID, gatewayFilter) => ({
    type: DELETE_GATEWAY_REQUEST,
    gatewayID,
    organizationID,
    gatewayFilter
});

export const clearStore = () => {
    return {
        type: CLEAR_STORE
    };
};
